import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Select, DatePicker, Button } from 'antd';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { TERRITORY } from '../../reducers';
import styles from '../styles';
import { getFilteringState } from '../reducers';
import { change_popup_details_view_state } from '../actions';

const { Option } = Select;

function showFilter(filter) {
  return (
    filter.active_agents ||
    filter.active_agent_without_disbursement_cashout ||
    filter.active_agent_partner_payment_only ||
    filter.dh_stock_progress ||
    filter.leading_agents ||
    filter.leading_agent_tpv ||
    filter.leading_agent_category ||
    filter.milking_agent
  );
}

const RightSidebarContent = ({ ...props }) => {
  const [open, setOpen] = useState(
    props.selectedState !== TERRITORY ||
      props.filteringState.dh_stock_balance_lifting ||
      props.filteringState.dh_stock_progress ||
      props.filteringState.dh_stock_balance_agent
      ? false
      : true
  );
  const { classes } = props;

  useEffect(() => {
    if (
      props.selectedState !== TERRITORY ||
      props.filteringState.dh_stock_balance_lifting ||
      props.filteringState.dh_stock_progress ||
      props.filteringState.dh_stock_balance_agent
    )
      setOpen(false);
    else setOpen(true);
  }, [props.selectedState]);

  useEffect(() => {
    if (
      props.selectedState !== TERRITORY ||
      props.filteringState.dh_stock_balance_lifting ||
      props.filteringState.dh_stock_progress ||
      props.filteringState.dh_stock_balance_agent
    )
      setOpen(false);
    else setOpen(true);
  }, [props.filteringState]);

  return (
    <div className={classes.rightSidebarDrawerWrapperRoot}>
      <div
        className={classNames({
          [classes.drawerWrapperOpen]: open,
          [classes.drawerWrapperClose]: !open
        })}
      >
        <div className={classes.datePicker}>
          {showFilter(props.filteringState) && (
            <React.Fragment>
              {!(
                props.filteringState.active_agents ||
                props.filteringState
                  .active_agent_without_disbursement_cashout ||
                props.filteringState.active_agent_partner_payment_only
              ) && (
                <Select
                  defaultValue={props.defaultFilterType}
                  style={{ width: 80 }}
                  onChange={props.actionOnTypeChange}
                >
                  <Option value="daily">Daily</Option>
                  <Option value="weekly">Weekly</Option>
                  <Option value="monthly">Monthly</Option>
                </Select>
              )}
              <div>
                <DatePicker
                  defaultValue={props.defaultDateRange}
                  style={{ width: 120 }}
                  onChange={props.actionOnDateChange}
                />
              </div>
            </React.Fragment>
          )}
          <Button
            style={{ background: '#FFCB37' }}
            onClick={() => {
              props.change_popup_details_view_state(true);
            }}
          >
            Details
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  filteringState: getFilteringState(state)
});

const mapDispatchToProps = {
  change_popup_details_view_state
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RightSidebarContent));
